import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { LoadingComponent } from './loading/loading.component';
import { ImageEnlargerComponent } from './image-enlarger/image-enlarger.component';
import { ErrorMessagesComponent } from './error-messages/error-messages.component';

const COMPONENTS = [
  LoadingComponent,
  ImageEnlargerComponent,
  ErrorMessagesComponent,
];



@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    PrimengModule,
  ],
  exports: COMPONENTS
})
export class UtilitiesModule { }
